<template>
  <div id="add_chat_user" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Direct Chat</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="input-group m-b-30">
            <input
              v-model="contactListParam.name"
              placeholder="Search to start a chat"
              class="form-control search-input"
              type="text"
              @change="filterContactListByName"
            />
            <span class="input-group-append">
              <button @click="filterContactListByName" class="btn btn-primary">Search</button>
            </span>
          </div>
          <div>
            <!-- <h5>Recent Conversations</h5> -->
            <ul class="chat-user-list" style="max-height: 300px;overflow: auto;">
              <!-- <ul class="chat-user-list"> -->
              <li v-if="loadingMessage">
                <a href="#">
                  <div class="media">
                    <span class="avatar align-self-center">
                      <img src="@/assets/profiles/avatar-16.jpg" alt />
                    </span>
                    <div class="media-body align-self-center text-nowrap">
                      <div class="user-name">
                        <Skeleton :count="1" />
                      </div>
                      <span class="designation">
                        <Skeleton :count="1" />
                      </span>
                      <span class="designation">
                        <Skeleton :count="1" />
                      </span>
                    </div>
                    <!-- <div class="text-nowrap align-self-center">
                      <div class="online-date">1 day ago</div>
                    </div>-->
                  </div>
                </a>
              </li>
              <li v-for="row in contactListArr" :key="`${row.id}`">
                <a href="javascript:void(0)" data-dismiss="modal" @click="addDirectChat(row)">
                  <div class="media">
                    <span class="avatar align-self-center">
                      <img src="@/assets/profiles/avatar-16.jpg" alt />
                    </span>
                    <div class="media-body align-self-center text-nowrap">
                      <div class="user-name">
                        <span v-if="row.first_name==''" class="contact-name text-ellipsis">No-Name</span>
                        <span v-else class="contact-name text-ellipsis">
                          {{row.first_name}}
                          {{row.last_name}}
                        </span>
                      </div>
                      <span class="designation" v-if="row.phone_number!='0'">
                        <i class="fa fa-phone-square"></i>
                        {{row.phone_number}}
                      </span>
                      <span class="designation" v-if="row.email!=''">
                        <i class="fa fa-envelope-o"></i>
                        {{row.email}}
                      </span>
                    </div>
                    <!-- <div class="text-nowrap align-self-center">
                      <div class="online-date">1 day ago</div>
                    </div>-->
                  </div>
                </a>
              </li>
            </ul>
            <infinite-loading-contact
              ref="infiniteLoading"
              :identifier="infiniteId"
              spinner="spiral"
              @infinite="infiniteHandlerContact"
            >
              <div slot="spinner">
                <span v-if="loadingMessage">Loading...</span>
              </div>
              <!-- <div slot="no-more">No more messages</div> -->
              <div slot="no-more">
                <span
                  v-if="(this.contactListParam.totalRecords>0 && this.contactListParam.rendered>=this.contactListParam.totalRecords)"
                >No more messages</span>
                <span v-if="(this.contactListParam.totalRecords==0)">No more messages</span>
                <span
                  v-if="(this.contactListParam.totalRecords>0 && this.contactListParam.rendered==0)"
                >No more messages</span>
              </div>
              <div slot="no-results">
                <span v-if="(this.contactListParam.totalRecords==0)">No results message</span>
                <span v-else>No more messages</span>
              </div>
            </infinite-loading-contact>
          </div>
          <!-- <div class="submit-section">
            <button class="btn btn-primary submit-btn">Submit</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters } from "vuex";

export default {
  components: {
    InfiniteLoadingContact: InfiniteLoading,
    Skeleton
  },
  data() {
    return {
      currentState: null,
      infiniteId: +new Date(),
      showUpdate: "",
      loadingGroup: false,
      currentState: null,
      loadingMessage: true,
      initScrollTop: 0,
      newData: [],
      currentGroupId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      contactListParam: {
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      }
    };
  },
  watch: {
    isShowDirectChats: {
      handler: function(val, oldVal) {
        console.log("isShowDirectChats:oldVal", oldVal);
        console.log("newVal", val);
        if (val == true) {
          //   this.filterContactListByName();
          //   this.$nextTick(() => {
          this.changeContactListArr([]);
          this.infiniteHandlerContact();

          //   this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
          //   });
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    isShowDirectChats() {
      return this.$store.state.omniroom.isShowDirectChats;
    },
    contactListArr() {
      return this.$store.state.contact.contactListArr;
    },
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },
  methods: {
    addDirectChat(row) {
      var unixTimestamp = Math.round(+new Date() / 1000);

      var newRoom = {
        id: "new-room",
        license_id: this.agentSession.license_id,
        provider: "whatsapp",
        room_title: row.first_name,
        room_number: row.phone_number + "@s.whatsapp.net",
        room_photo: "",
        room_last_chat_name: row.first_name,
        room_last_chat_message: "",
        is_deleted: 0,
        create_datetime: unixTimestamp,
        update_datetime: unixTimestamp,
        num_unread: 0,
        is_group: 0
      };
      this.$root.$emit("addDirectChat", newRoom);
    },
    actShowHideUpdate(value) {
      this.showUpdate = value;
    },
    async filterContactListByName() {
      this.changeContactListArr([]);

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 10;
      this.contactListParam.group_id = [];
      this.infiniteId += 1;

      //   this.infiniteHandlerContact();
    },
    async filterContactListGroup(groupId) {
      this.currentGroupId = groupId;
      this.changeContactListArr([]);

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 10;
      this.contactListParam.group_id = [];
      if (groupId !== "") {
        this.contactListParam.group_id.push(groupId);
      }
      this.infiniteId += 1;

      //   this.infiniteHandlerContact();
    },
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.contactListParam) // sesuai kan dengan method di API
        .catch(error => {
          //   this.loading = false;
          this.loadingGroup = false;

          console.log("error", error);
        });
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    async changeContactListArr(data) {
      var newArr = await this.getUniqueListBy(data, "id");
      await this.$store.dispatch("contact/setContactListArr", newArr);
    },
    async infiniteHandlerContact($state) {
      this.loadingMessage = await true;

      await this.$store
        .dispatch("contact/getContactList", this.contactListParam) // sesuai kan dengan method di API
        .then(response => {
          console.log("response", response);
          console.log("response.data.length", response.data.length);
          const { data } = response;
          this.newData = data;
          if (this.newData.length > 0) {
            this.contactListArr.push(...this.newData);
            this.changeContactListArr(this.contactListArr);
            this.contactListParam.rendered =
              this.contactListParam.page + response.recordsFiltered;
            this.contactListParam.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.contactListParam.totalRecords = response.totalRecords;
            }

            this.loadingMessage = false;
            // this.infiniteHandler(this.currentState, 0, 0);
            // $state.loaded();
          } else {
            this.loadingMessage = false;
            // $state.completed();
          }
          console.log("statttt", $state);
        })
        .catch(error => {
          this.loadingMessage = false;

          console.log("error", error);
        });
      this.currentState = await $state;
    }
  },
  async created() {
    // this.getContactList();
    // this.changeContactListArr([]);
    // this.getGroupList();
    // this.$root.$on("infiniteHandlerContact", () => {
    //   this.infiniteHandlerContact();
    // });
  },
  beforeDestroy() {
    // this.$root.$off("infiniteHandlerContact");
  },
  mounted() {
    var listElmDc = document.querySelector(".chat-user-list");
    listElmDc.addEventListener("scroll", e => {
      var currentScroll = listElmDc.scrollHeight - listElmDc.scrollTop;
      //   console.log("listElm.scrollTop::", listElm.scrollTop);
      //   console.log("listElm.clientHeight::", listElm.clientHeight);
      //   console.log("listElm.scrollHeight::", listElm.scrollHeight);

      console.log(
        "this.contactListParam.totalRecords",
        this.contactListParam.totalRecords
      );
      console.log("rendered", this.contactListParam.rendered);
      if (currentScroll == listElmDc.clientHeight) {
        console.log("this.contactListParam: ", this.contactListParam);
        console.log("end scroll");
        if (
          this.contactListParam.totalRecords > 0 &&
          this.contactListParam.rendered < this.contactListParam.totalRecords
        ) {
          this.infiniteHandlerContact();
          listElmDc.scrollTop = listElmDc.scrollTop - 10;
        }
      }

      // if (
      //   listElm.scrollHeight - listElm.scrollTop <=
      //   listElm.clientHeight + 50
      // ) {
      //   this.getUsers();
      // }

      //   console.log("calc", listElm.scrollHeight - listElm.scrollTop);
      //   console.log("calc2", listElm.clientHeight + 50);

      //   if (listElm.scrollTop === 0) {
      //     // if (listElm.scrollTop <= listElm.clientHeight) {
      //     // if (listElm.scrollTop + listElm.clientHeight === listElm.scrollHeight) {
      //     // console.log("dipucuk");
      //     this.infiniteHandlerContact(this.currentState);
      //     // console.log("this.hotChatParam.rendered", this.hotChatParam.totalData);
      //     // listElm.scrollTop = listElm.clientHeight;
      //     // listElm.scrollTop = 4679;
      //     listElm.scrollTop = 4500;
      //     // console.log("listElm.scrollTop::this.initScrollTop", listElm.scrollTop);

      //     // this.initScrollTop = listElm.scrollHeight;
      //     // console.log(
      //     //   "listElm.scrollTop::this.initScrollTop",
      //     //   this.initScrollTop
      //     // );

      //     // return;
      //     // this.scrollToBottom(true);
      //   } else {
      //     //stop loadmore
      //     this.infiniteHandlerContact(this.currentState);
      //   }
    });
  },
  name: "directChat"
};
</script>


// WEBPACK FOOTER //
// src/views/omni/direct.vue